// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  position: fixed;
  z-index: 1000;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #2454a3;
  background-image: linear-gradient(rgba(33, 78, 182, 0.44), rgba(33, 78, 182, 0.44)), var(--login-background-image);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.login-page__overlay {
  display: none;
}

.login-page__main,
.login-page__content {
  width: 100%;
  min-height: 100%;
}

.login-page__main {
  display: flex;
  height: 100%;
  background-image: linear-gradient(rgba(33, 78, 182, 0.44), rgba(33, 78, 182, 0.44)), var(--login-background-image);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  animation: loginBackgroundReveal 700ms ease-out both;
}

.login-page__content {
  display: flex;
  width: 100%;
  min-height: 100%;
  flex: 1 1;
  align-items: center;
  justify-content: center;
  padding: clamp(16px, 3.5vh, 34px) 16px;
}

.login-page .login-card {
  width: min(100%, 560px);
  height: auto;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.34);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.31);
  box-shadow: 0 18px 45px rgba(19, 42, 94, 0.22);
  backdrop-filter: blur(13px);
  -webkit-backdrop-filter: blur(13px);
  animation: loginCardEnter 560ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.login-page .login-card__body {
  padding: 36px 38px 25px;
}

.login-card__logo-wrap {
  display: flex;
  min-height: 130px;
  align-items: center;
  justify-content: center;
}

.login-page .login-card__logo {
  display: block;
  width: min(100%, 340px);
  height: 130px;
  border-radius: 6px;
  background: #ffffff;
  object-fit: contain;
  animation: loginLogoFloat 4.5s ease-in-out 800ms infinite;
}

.login-card__intro {
  margin: 16px 0 20px;
}

.login-page .login-card__title {
  color: #000000;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.25;
}

.login-page .login-card__title h6 {
  margin: 2px 0 0;
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
}

.login-page .login-card__form {
  display: flex;
  flex-direction: column;
  gap: 17px;
}

.login-page .login-card__field label {
  display: block;
  margin-bottom: 8px;
  color: #000000;
  font-size: 14px;
  font-weight: 600;
}

.login-card__input-wrap {
  position: relative;
}

.login-page .login-card__field input {
  display: block;
  width: 100%;
  height: 50px;
  padding: 0 42px 0 12px;
  border: 1px solid rgba(200, 214, 235, 0.9);
  border-radius: 1px;
  background: rgba(240, 246, 255, 0.91);
  color: #111827;
  font-size: 14px;
  box-shadow: none;
  outline: none;
  transition: border-color 150ms ease, box-shadow 150ms ease, background-color 150ms ease;
}

.login-page .login-card__field input:focus {
  border-color: #176dd0;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 0 0 3px rgba(23, 109, 208, 0.14);
}

.login-card__password-toggle {
  position: absolute;
  top: 26px;
  right: 0;
  bottom: 0;
  display: inline-flex;
  width: 42px;
  height: 50px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #07182e;
  cursor: pointer;
  margin: auto 0;
}

.login-card__password-toggle svg {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  overflow: visible;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
  transform: translate(-50%, -50%);
}

.login-card__password-toggle .login-card__password-slash {
  stroke-width: 2.2;
}

.login-card__password-toggle:hover {
  color: #075abd;
}

.login-card__password-toggle:focus-visible {
  border-radius: 4px;
  outline: 2px solid #176dd0;
  outline-offset: -2px;
}

.login-page .login-card__actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 7px;
}

.login-page .login-card__button {
  display: inline-flex;
  width: 100%;
  min-height: 52px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 9px 12px;
  border: 1px solid #0055be;
  border-radius: 1px;
  background: #075abd;
  color: #ffffff !important;
  box-shadow: none;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

.login-page .login-card__button i,
.login-page .login-card__button span {
  display: inline-block;
  color: #ffffff !important;
  line-height: 1;
}

.login-page .login-card__button i {
  width: 16px;
  font-size: 14px;
  text-align: center;
}

.login-page .login-card__button span {
  font-size: 13px;
  font-weight: 700;
}

.login-page .login-card__button:hover,
.login-page .login-card__button:focus-visible {
  background: #064ca0;
  color: #ffffff;
  box-shadow: 0 7px 16px rgba(4, 76, 160, 0.25);
  outline: none;
  transform: translateY(-1px);
}

.login-page .login-card__button:active {
  box-shadow: none;
  transform: translateY(0) scale(0.985);
}

.login-page .login-card__device {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  padding: 0 24px 24px;
}

.login-page .login-card__device-badge {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  gap: 5px;
  overflow: hidden;
  padding: 5px 13px;
  border-radius: 999px;
  background: #263875;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(38, 56, 117, 0.38), 0 0 15px rgba(38, 56, 117, 0.24);
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  animation: loginDeviceBadge 3.2s ease-in-out 1s infinite;
}

@keyframes loginBackgroundReveal {
  from {
    opacity: 0.72;
    transform: scale(1.012);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes loginCardEnter {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.975);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes loginLogoFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}
@keyframes loginDeviceBadge {
  0%, 100% {
    box-shadow: 0 4px 12px rgba(38, 56, 117, 0.38), 0 0 12px rgba(38, 56, 117, 0.18);
  }
  50% {
    box-shadow: 0 5px 14px rgba(38, 56, 117, 0.44), 0 0 18px rgba(76, 103, 191, 0.32);
  }
}
.login-card__reset-title {
  margin: 0;
  color: #000000;
  font-size: 19px;
  font-weight: 700;
}

.login-card__reset-copy {
  margin: 8px 0 18px;
  color: #172033;
  font-size: 13px;
  line-height: 1.5;
}

.login-page .login-card__return {
  padding: 7px;
  border: 0;
  background: transparent;
  color: #073e82;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

@media (max-width: 480px) {
  .login-page {
    background-position: 58% center;
  }
  .login-page__content {
    align-items: center;
    padding: 14px 12px;
  }
  .login-page .login-card {
    border-radius: 8px;
  }
  .login-page .login-card__body {
    padding: 20px 18px 15px;
  }
  .login-card__logo-wrap {
    min-height: 88px;
  }
  .login-page .login-card__logo {
    width: min(100%, 250px);
    height: 88px;
  }
  .login-card__intro {
    margin: 9px 0 13px;
  }
  .login-page .login-card__form {
    gap: 13px;
  }
  .login-page .login-card__field label {
    margin-bottom: 6px;
  }
  .login-page .login-card__field input,
  .login-card__password-toggle {
    height: 44px;
  }
  .login-page .login-card__button {
    min-height: 44px;
  }
  .login-page .login-card__device {
    padding: 0 13px 14px;
  }
}
@media (max-width: 340px) {
  .login-page .login-card__actions {
    grid-template-columns: 1fr;
  }
}
@media (max-height: 620px) and (min-width: 481px) {
  .login-page__content {
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .login-page .login-card__body {
    padding: 13px 20px 10px;
  }
  .login-card__logo-wrap {
    min-height: 58px;
  }
  .login-page .login-card__logo {
    width: 180px;
    height: 58px;
  }
  .login-card__intro {
    margin: 5px 0 8px;
  }
  .login-page .login-card__form {
    gap: 7px;
  }
  .login-page .login-card__field label {
    margin-bottom: 3px;
    font-size: 12px;
  }
  .login-page .login-card__field input {
    height: 35px;
  }
  .login-card__password-toggle {
    height: 35px;
  }
  .login-page .login-card__button {
    min-height: 35px;
    padding: 6px 10px;
  }
  .login-page .login-card__device {
    padding-bottom: 10px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .login-page * {
    animation: none !important;
    transition-duration: 0.01ms !important;
  }
  .login-page__main {
    animation: none !important;
  }
}
.login-page .login-card__device {
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
}

.login-page .login-card__manual {
  text-decoration: none;
}

.login-page .login-card__manual:hover {
  background: #1b2b60;
  color: #ffffff;
}

.login-page .login-card__manual:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 3px;
}

/* Hide Device Code and User Manual on tablet */
@media (min-width: 768px) and (max-width: 1024px) {
  .login-card__manual {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/login/Login.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kHACE;EAEF,2BAAA;EACA,4BAAA;EACA,sBAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;;EAEE,WAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,YAAA;EACA,kHACE;EAEF,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,oDAAA;AAHF;;AAMA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;AAHF;;AAMA;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,2CAAA;EACA,kBAAA;EACA,qCAAA;EACA,8CAAA;EACA,2BAAA;EACA,mCAAA;EACA,mEAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,cAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yDAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAHF;;AAMA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,0CAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,uFACE;AAJJ;;AASA;EACE,qBAAA;EACA,qCAAA;EACA,8CAAA;AANF;;AASA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AANF;;AASA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gCAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;AANF;;AASA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,eAAA;AANF;;AASA;EACE,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,oFACE;AAPJ;;AAYA;;EAEE,qBAAA;EACA,yBAAA;EACA,cAAA;AATF;;AAYA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;AATF;;AAYA;;EAEE,mBAAA;EACA,cAAA;EACA,6CAAA;EACA,aAAA;EACA,2BAAA;AATF;;AAYA;EACE,gBAAA;EACA,qCAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,oBAAA;AATF;;AAYA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,gFACE;EAEF,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,wDAAA;AAXF;;AAcA;EACE;IACE,aAAA;IACA,uBAAA;EAXF;EAcA;IACE,UAAA;IACA,mBAAA;EAZF;AACF;AAeA;EACE;IACE,UAAA;IACA,wCAAA;EAbF;EAgBA;IACE,UAAA;IACA,iCAAA;EAdF;AACF;AAiBA;EACE;IAEE,wBAAA;EAhBF;EAmBA;IACE,2BAAA;EAjBF;AACF;AAoBA;EACE;IAEE,gFACE;EApBJ;EAwBA;IACE,iFACE;EAvBJ;AACF;AA2BA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAzBF;;AA4BA;EACE;IACE,+BAAA;EAzBF;EA4BA;IACE,mBAAA;IACA,kBAAA;EA1BF;EA6BA;IACE,kBAAA;EA3BF;EA8BA;IACE,uBAAA;EA5BF;EA+BA;IACE,gBAAA;EA7BF;EAgCA;IACE,uBAAA;IACA,YAAA;EA9BF;EAiCA;IACE,kBAAA;EA/BF;EAkCA;IACE,SAAA;EAhCF;EAmCA;IACE,kBAAA;EAjCF;EAoCA;;IAEE,YAAA;EAlCF;EAqCA;IACE,gBAAA;EAnCF;EAsCA;IACE,oBAAA;EApCF;AACF;AAuCA;EACE;IACE,0BAAA;EArCF;AACF;AAwCA;EACE;IACE,mBAAA;IACA,iBAAA;IACA,oBAAA;EAtCF;EAyCA;IACE,uBAAA;EAvCF;EA0CA;IACE,gBAAA;EAxCF;EA2CA;IACE,YAAA;IACA,YAAA;EAzCF;EA4CA;IACE,iBAAA;EA1CF;EA6CA;IACE,QAAA;EA3CF;EA8CA;IACE,kBAAA;IACA,eAAA;EA5CF;EA+CA;IACE,YAAA;EA7CF;EAgDA;IACE,YAAA;EA9CF;EAiDA;IACE,gBAAA;IACA,iBAAA;EA/CF;EAkDA;IACE,oBAAA;EAhDF;AACF;AAmDA;EACE;IACE,0BAAA;IACA,sCAAA;EAjDF;EAoDA;IACE,0BAAA;EAlDF;AACF;AAqDA;EACE,eAAA;EACA,8BAAA;EACA,SAAA;AAnDF;;AAsDA;EACE,qBAAA;AAnDF;;AAsDA;EACE,mBAAA;EACA,cAAA;AAnDF;;AAsDA;EACE,0BAAA;EACA,mBAAA;AAnDF;;AAsDA,+CAAA;AACA;EACE;IACE,wBAAA;EAnDF;AACF","sourcesContent":[".login-page {\n  position: fixed;\n  z-index: 1000;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background-color: #2454a3;\n  background-image:\n    linear-gradient(rgba(33, 78, 182, 0.44), rgba(33, 78, 182, 0.44)),\n    var(--login-background-image);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.login-page__overlay {\n  display: none;\n}\n\n.login-page__main,\n.login-page__content {\n  width: 100%;\n  min-height: 100%;\n}\n\n.login-page__main {\n  display: flex;\n  height: 100%;\n  background-image:\n    linear-gradient(rgba(33, 78, 182, 0.44), rgba(33, 78, 182, 0.44)),\n    var(--login-background-image);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  animation: loginBackgroundReveal 700ms ease-out both;\n}\n\n.login-page__content {\n  display: flex;\n  width: 100%;\n  min-height: 100%;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  padding: clamp(16px, 3.5vh, 34px) 16px;\n}\n\n.login-page .login-card {\n  width: min(100%, 560px);\n  height: auto;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.34);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.31);\n  box-shadow: 0 18px 45px rgba(19, 42, 94, 0.22);\n  backdrop-filter: blur(13px);\n  -webkit-backdrop-filter: blur(13px);\n  animation: loginCardEnter 560ms cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.login-page .login-card__body {\n  padding: 36px 38px 25px;\n}\n\n.login-card__logo-wrap {\n  display: flex;\n  min-height: 130px;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-page .login-card__logo {\n  display: block;\n  width: min(100%, 340px);\n  height: 130px;\n  border-radius: 6px;\n  background: #ffffff;\n  object-fit: contain;\n  animation: loginLogoFloat 4.5s ease-in-out 800ms infinite;\n}\n\n.login-card__intro {\n  margin: 16px 0 20px;\n}\n\n.login-page .login-card__title {\n  color: #000000;\n  font-size: 17px;\n  font-weight: 500;\n  line-height: 1.25;\n}\n\n.login-page .login-card__title h6 {\n  margin: 2px 0 0;\n  color: #000000;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.35;\n}\n\n.login-page .login-card__form {\n  display: flex;\n  flex-direction: column;\n  gap: 17px;\n}\n\n.login-page .login-card__field label {\n  display: block;\n  margin-bottom: 8px;\n  color: #000000;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.login-card__input-wrap {\n  position: relative;\n}\n\n.login-page .login-card__field input {\n  display: block;\n  width: 100%;\n  height: 50px;\n  padding: 0 42px 0 12px;\n  border: 1px solid rgba(200, 214, 235, 0.9);\n  border-radius: 1px;\n  background: rgba(240, 246, 255, 0.91);\n  color: #111827;\n  font-size: 14px;\n  box-shadow: none;\n  outline: none;\n  transition:\n    border-color 150ms ease,\n    box-shadow 150ms ease,\n    background-color 150ms ease;\n}\n\n.login-page .login-card__field input:focus {\n  border-color: #176dd0;\n  background: rgba(255, 255, 255, 0.97);\n  box-shadow: 0 0 0 3px rgba(23, 109, 208, 0.14);\n}\n\n.login-card__password-toggle {\n  position: absolute;\n  top:26px;\n  right: 0;\n  bottom: 0;\n  display: inline-flex;\n  width: 42px;\n  height: 50px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #07182e;\n  cursor: pointer;\n  margin: auto 0;\n}\n\n.login-card__password-toggle svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: block;\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  overflow: visible;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n  transform: translate(-50%, -50%);\n}\n\n.login-card__password-toggle .login-card__password-slash {\n  stroke-width: 2.2;\n}\n\n.login-card__password-toggle:hover {\n  color: #075abd;\n}\n\n.login-card__password-toggle:focus-visible {\n  border-radius: 4px;\n  outline: 2px solid #176dd0;\n  outline-offset: -2px;\n}\n\n.login-page .login-card__actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 7px;\n}\n\n.login-page .login-card__button {\n  display: inline-flex;\n  width: 100%;\n  min-height: 52px;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 9px 12px;\n  border: 1px solid #0055be;\n  border-radius: 1px;\n  background: #075abd;\n  color: #ffffff !important;\n  box-shadow: none;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition:\n    background-color 150ms ease,\n    box-shadow 150ms ease,\n    transform 150ms ease;\n}\n\n.login-page .login-card__button i,\n.login-page .login-card__button span {\n  display: inline-block;\n  color: #ffffff !important;\n  line-height: 1;\n}\n\n.login-page .login-card__button i {\n  width: 16px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.login-page .login-card__button span {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.login-page .login-card__button:hover,\n.login-page .login-card__button:focus-visible {\n  background: #064ca0;\n  color: #ffffff;\n  box-shadow: 0 7px 16px rgba(4, 76, 160, 0.25);\n  outline: none;\n  transform: translateY(-1px);\n}\n\n.login-page .login-card__button:active {\n  box-shadow: none;\n  transform: translateY(0) scale(0.985);\n}\n\n.login-page .login-card__device {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin: 0;\n  padding: 0 24px 24px;\n}\n\n.login-page .login-card__device-badge {\n  display: inline-flex;\n  max-width: 100%;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  overflow: hidden;\n  padding: 5px 13px;\n  border-radius: 999px;\n  background: #263875;\n  color: #ffffff;\n  box-shadow:\n    0 4px 12px rgba(38, 56, 117, 0.38),\n    0 0 15px rgba(38, 56, 117, 0.24);\n  font-size: 12px;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  animation: loginDeviceBadge 3.2s ease-in-out 1s infinite;\n}\n\n@keyframes loginBackgroundReveal {\n  from {\n    opacity: 0.72;\n    transform: scale(1.012);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes loginCardEnter {\n  from {\n    opacity: 0;\n    transform: translateY(18px) scale(0.975);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes loginLogoFloat {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-3px);\n  }\n}\n\n@keyframes loginDeviceBadge {\n  0%,\n  100% {\n    box-shadow:\n      0 4px 12px rgba(38, 56, 117, 0.38),\n      0 0 12px rgba(38, 56, 117, 0.18);\n  }\n\n  50% {\n    box-shadow:\n      0 5px 14px rgba(38, 56, 117, 0.44),\n      0 0 18px rgba(76, 103, 191, 0.32);\n  }\n}\n\n.login-card__reset-title {\n  margin: 0;\n  color: #000000;\n  font-size: 19px;\n  font-weight: 700;\n}\n\n.login-card__reset-copy {\n  margin: 8px 0 18px;\n  color: #172033;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.login-page .login-card__return {\n  padding: 7px;\n  border: 0;\n  background: transparent;\n  color: #073e82;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n@media (max-width: 480px) {\n  .login-page {\n    background-position: 58% center;\n  }\n\n  .login-page__content {\n    align-items: center;\n    padding: 14px 12px;\n  }\n\n  .login-page .login-card {\n    border-radius: 8px;\n  }\n\n  .login-page .login-card__body {\n    padding: 20px 18px 15px;\n  }\n\n  .login-card__logo-wrap {\n    min-height: 88px;\n  }\n\n  .login-page .login-card__logo {\n    width: min(100%, 250px);\n    height: 88px;\n  }\n\n  .login-card__intro {\n    margin: 9px 0 13px;\n  }\n\n  .login-page .login-card__form {\n    gap: 13px;\n  }\n\n  .login-page .login-card__field label {\n    margin-bottom: 6px;\n  }\n\n  .login-page .login-card__field input,\n  .login-card__password-toggle {\n    height: 44px;\n  }\n\n  .login-page .login-card__button {\n    min-height: 44px;\n  }\n\n  .login-page .login-card__device {\n    padding: 0 13px 14px;\n  }\n}\n\n@media (max-width: 340px) {\n  .login-page .login-card__actions {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-height: 620px) and (min-width: 481px) {\n  .login-page__content {\n    align-items: center;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  .login-page .login-card__body {\n    padding: 13px 20px 10px;\n  }\n\n  .login-card__logo-wrap {\n    min-height: 58px;\n  }\n\n  .login-page .login-card__logo {\n    width: 180px;\n    height: 58px;\n  }\n\n  .login-card__intro {\n    margin: 5px 0 8px;\n  }\n\n  .login-page .login-card__form {\n    gap: 7px;\n  }\n\n  .login-page .login-card__field label {\n    margin-bottom: 3px;\n    font-size: 12px;\n  }\n\n  .login-page .login-card__field input {\n    height: 35px;\n  }\n\n  .login-card__password-toggle {\n    height: 35px;\n  }\n\n  .login-page .login-card__button {\n    min-height: 35px;\n    padding: 6px 10px;\n  }\n\n  .login-page .login-card__device {\n    padding-bottom: 10px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .login-page * {\n    animation: none !important;\n    transition-duration: 0.01ms !important;\n  }\n\n  .login-page__main {\n    animation: none !important;\n  }\n}\n\n.login-page .login-card__device {\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.login-page .login-card__manual {\n  text-decoration: none;\n}\n\n.login-page .login-card__manual:hover {\n  background: #1b2b60;\n  color: #ffffff;\n}\n\n.login-page .login-card__manual:focus-visible {\n  outline: 2px solid #ffffff;\n  outline-offset: 3px;\n}\n\n/* Hide Device Code and User Manual on tablet */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .login-card__manual {\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
